import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const P_DOSSIER_SCHEMA_LITERAL = {
    title: 'Schéma PDossier',
    description: 'Décrit PDossier',
    version: 2,
    keyCompression: false,
    primaryKey: 'D_RAISONSOC',
    type: 'object',
    properties: {
        D_RAISONSOC: { type: 'string', maxLength : 35 },
        D_PROFESSION: { type: ['string', 'null'] },
        D_ADRESSE: { type: ['string', 'null'] },
        D_COMPLEMENT: { type: ['string', 'null'] },
        D_CODEPOSTAL: { type: ['string', 'null'] },
        D_VILLE: { type: ['string', 'null'] },
        D_CODEREGION: { type: ['string', 'null'] },
        D_PAYS: { type: ['string', 'null'] },
        D_EMAIL: { type: ['string', 'null'] },
        D_TELEPHONE: { type: ['string', 'null'] },
        D_TELECOPIE: { type: ['string', 'null'] },
        D_SITE: { type: ['string', 'null'] },
        D_SIRET: { type: ['string', 'null'] },
        D_APE: { type: ['string', 'null'] },
        D_IDENTIFIANT: { type: ['string', 'null'] },
        D_RCS: { type: ['string', 'null'] },
    },
    required: [ 'D_RAISONSOC' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(P_DOSSIER_SCHEMA_LITERAL);
export type RxPDossierDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const P_DOSSIER_SCHEMA: RxJsonSchema<RxPDossierDocumentType> = P_DOSSIER_SCHEMA_LITERAL;
